'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useEmbroideryPrice } from '@/hooks/useEmbroideryPrice';
import { DiscountedPrice } from '@/components/Price/DiscountedPrice';
import { Locale } from '@/utility/locale';
import { tracker } from '@/utility/tracking/tracker';
type EmbroideryAwarePriceProps = {
  basePrice: number;
  productTypeId: string;
  locale: Locale;
  partnerId: string;
  sellable: Sellable;
};
export const EmbroideryAwarePrice = t0 => {
  const $ = _c(12);
  const {
    basePrice,
    productTypeId,
    locale,
    partnerId,
    sellable
  } = t0;
  let t1;
  if ($[0] !== basePrice || $[1] !== locale || $[2] !== partnerId || $[3] !== productTypeId || $[4] !== sellable) {
    t1 = {
      basePrice,
      productTypeId,
      locale,
      partnerId,
      sellable
    };
    $[0] = basePrice;
    $[1] = locale;
    $[2] = partnerId;
    $[3] = productTypeId;
    $[4] = sellable;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const displayPrice = useEmbroideryPrice(t1);
  let t2;
  let t3;
  if ($[6] !== displayPrice) {
    t2 = () => {
      tracker.trackClientProduct({
        product: {
          price: displayPrice
        }
      });
    };
    t3 = [displayPrice];
    $[6] = displayPrice;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  const t4 = Number(displayPrice);
  let t5;
  if ($[9] !== productTypeId || $[10] !== t4) {
    t5 = <DiscountedPrice price={t4} productTypeId={productTypeId} currentDiscountAmount={0} />;
    $[9] = productTypeId;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};